import type {Expand} from '../../types';

export const editionExpandCommon: Expand = {
  edition: ['contract_id', 'materials.file_ids', 'tasks.coach_attachment_ids'],
};
